module.exports = __webpack_public_path__ + "static/media/imagemMaoDireita.07198d47.png";